import ReactGA from "react-ga"

export const initGA = (): void => {
    ReactGA.initialize('UA-176069950-1')
}

export const GAPageView = (page: string): void => {
    ReactGA.pageview(page)
}

export const GAEvent = (categoryName: string, eventName: string, labelName: string): void => {
    ReactGA.event({
        category: categoryName,  // Required
        action: eventName,       // Required
        label: labelName,
        value: 10,
        nonInteraction: false
    });
}
